<ng-template #thankYouModal>
    <div class="thank-you-modal">
        <div class="modal-body">
            <div class="d-flex justify-content-center flex-column" style="min-height: 85px;">
                <div>
                    {{ 'modal.thankYou.body' | translate }}
                </div>
            </div>
            <div class="btn-modal">
                <span (click)="hideModal()">OK</span>
            </div>
        </div>
    </div>
</ng-template>
